import React from 'react';

import { graphql, Link } from 'gatsby';

import { SxProps } from '@mui/material';

import { ConversionTeaserImage, extractTextMarking } from '@mewa/ui';

import { StrapiImage, StrapiResponsiveImageData } from './image';

export const ConversionTeaserImageFragment = graphql`
  fragment ConversionTeaserImageFragment on STRAPI__COMPONENT_SHARED_CONVERSION_TEASER_IMAGE {
    conversionHeadline
    conversionSubline
    conversionImage {
      ...StrapiImageFragment
    }
    conversionCta {
      text
      url
    }
  }
`;

export type ConversionTeaserImageData = {
  conversionHeadline: string;
  conversionSubline: string;
  conversionImage: StrapiResponsiveImageData;
  conversionCta: {
    text: string;
    url: string;
  };
};

export const StrapiConversionTeaserImage = ({
  data,
  piwikEventNameCTA,
  onClick,
  sx,
  className = '',
}: {
  data: ConversionTeaserImageData;
  piwikEventNameCTA: string;
  onClick?: () => void;
  sx?: SxProps;
  className?: string;
}) => {
  const headline = extractTextMarking(data.conversionHeadline);

  return (
    <ConversionTeaserImage
      headline={
        <>
          {headline.beforeMarking}
          <strong>{headline.marking}</strong>
          {headline.afterMarking}
        </>
      }
      content={data.conversionSubline}
      image={<StrapiImage responsiveImage={data.conversionImage} />}
      labelCTA={data.conversionCta.text}
      link={{ component: Link, props: { to: data.conversionCta.url } }}
      piwikEventNameCTA={piwikEventNameCTA}
      className={className}
      onClick={onClick}
      sx={sx}
    />
  );
};
